import { render, staticRenderFns } from "./CulturalGoodsDetail.vue?vue&type=template&id=d8014cd4&"
import script from "./CulturalGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./CulturalGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CulturalGoodsDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports